<div class="v3-image-crop">
  <div class="v3-image-crop__head">
    <h2 class="v3-image-crop__title subsection-title">
      {{ 'translations.global.imageCrop.title' | transloco }}
    </h2>
    <button
      type="button"
      class="v3-image-crop__close"
      (click)="cancelCrop()"
      [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
    >
      <ptl-icon [icon]="LucideX" [size]="'m'"></ptl-icon>
    </button>
  </div>

  <div class="v3-image-crop__body">
    @if (description) {
      <p class="v3-image-crop__description fs-body-s">{{ description }}</p>
    }

    @if (isAnimatedGif) {
      <div class="v3-image-crop__gif">
        <img [src]="imageBase64" [alt]="'translations.global.imageCrop.animatedGifAlt' | transloco" />
      </div>
    } @else {
      <div class="v3-image-crop__cropper">
        <image-cropper
          [imageFile]="imageFile"
          [imageBase64]="imageBase64"
          [containWithinAspectRatio]="maintainAspectRatio"
          [maintainAspectRatio]="maintainAspectRatio"
          [aspectRatio]="aspectRatio"
          [roundCropper]="roundCropper"
          [resizeToWidth]="resizeToWidth"
          [resizeToHeight]="resizeToHeight"
          [backgroundColor]="backgroundColor"
          [format]="imageFormat"
          (imageCropped)="updateCroppedImage($event)"
        ></image-cropper>
      </div>
    }
  </div>

  <div class="v3-image-crop__footer">
    <ptl-button [type]="'secondary-neutral'" [text]="'translations.global.button.cancel' | transloco" (clicked)="cancelCrop()"></ptl-button>
    <ptl-button
      data-testid="image-crop-apply"
      [type]="'dark'"
      [text]="'translations.global.button.apply' | transloco"
      (clicked)="saveCrop()"
    ></ptl-button>
  </div>
</div>
